export const showLimitFlag = (
  dailyRemainingDoubtsCount,
  dailyRemainingOpenDoubtsCount
) => {
  if (
    dailyRemainingDoubtsCount === 0 ||
    dailyRemainingDoubtsCount === 1 ||
    dailyRemainingOpenDoubtsCount === 0
  )
    return true;
  return false;
};

export const getHeadingMessageImageUrl = (
  dailyRemainingDoubtsCount,
  dailyRemainingOpenDoubtsCount,
  dailyTotalDoubtsCount,
  dailyTotalOpenDoubtsCount
) => {
  let heading = null;
  let message = null;
  let imgSrc = null;
  let msgWidth = null;
  let statusCode = null;
  if (dailyRemainingDoubtsCount === 0) {
    heading = 'Daily limit reached';
    message = `You’ve reached the daily limit of ${dailyTotalDoubtsCount} doubts. Ask a new doubt tomorrow.`;
    msgWidth = '300px';
    imgSrc = 'doubts20/dailyLimitReached.svg';
    statusCode = 1;
  } else if (dailyRemainingOpenDoubtsCount === 0) {
    heading = 'Wait until the pending doubts are solved';
    message = `You have ${dailyTotalOpenDoubtsCount} doubts awaiting solutions.            
    Submit new doubts once they’re solved.`;
    imgSrc = 'doubts20/tooManyPendingDoubt.svg';
    msgWidth = '290px';
    statusCode = 3;
  } else if (dailyRemainingDoubtsCount === 1) {
    heading = 'Last doubt of the day';
    message =
      'You have one doubt remaining for the day. You can ask more doubts tomorrow.';
    imgSrc = 'doubts20/lastDoubt.svg';
    msgWidth = '300px';
    statusCode = 2;
  }
  return {
    heading,
    message,
    imgSrc,
    msgWidth,
    statusCode
  };
};
